import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import locale from 'element-ui/lib/locale/lang/en'
import axios from "./axios/axios.js";
import VueI18n from 'vue-i18n';
import { messages } from './components/common/i18n';
// import 'element-ui/lib/theme-chalk/index.css'; // 默认主题
import './assets/css/theme-self/index.css'; // 自定义#8BB644主题
import './assets/css/icon.css';
import './components/common/directives';
import 'babel-polyfill';
//引入cytoscape
import cytoscape from 'cytoscape';
//引入文件
import http from './api/http'
// 自定义组件
import vuePlugin from './vuePlugin'
Vue.use(vuePlugin)

//挂载到VUE实例，以便全局使用
Vue.prototype.http = http;
Vue.prototype.$cytoscape = cytoscape;
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
Vue.use(VueI18n);
Vue.use(ElementUI, {
    locale,
    size: 'small'
});
const i18n = new VueI18n({
    locale: 'en',
    messages
});

//使用钩子函数对路由
router.beforeEach((to, from, next) => {
    window.scrollTo(0, 0);
    var footer_div = document.getElementsByClassName('footer')[0]
    if (footer_div) {
        if (to.path === "/homePage") {
            footer_div.style.backgroundColor = "rgba(245, 249, 252, 1)";
        }
        else {
            footer_div.style.backgroundColor = "rgba(255, 255, 255, 1)";
        }
    }
    next()
});

new Vue({
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');
